import { DataForm, FieldProps, FieldType } from 'components';
import { Drawers } from 'app/types/drawer';
import { useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { selectors, useSendEmailMutation } from 'app/services/projects';
import { useGetUnitQuery, useGetUserQuery } from 'app/services/me';
import { useGetUnitSignatureQuery } from 'app/services/units/api';
import { Skeleton } from 'antd';
import { buildProjectEmail, buildSenderSignature } from 'utils/email';
import { useTranslation } from 'react-i18next';
import NoSignature from '../NoSignatureAlert';

const SendEmail = () => {
  const project = useSelector(selectors.getProject);
  const [ sendEmail, meta ] = useSendEmailMutation();
  const { data: user, isLoading: userLoading } = useGetUserQuery();
  const { data: unit, isLoading: unitLoading } = useGetUnitQuery({ persist: true });
  const { data: unitSignature, isLoading: signatureLoading, isUninitialized: signatureNotStarted } =
    useGetUnitSignatureQuery(user?.UnitId ?? skipToken);
  const { t } = useTranslation();

  // The message is the form's initial value, so it can only be built once the signature is known.
  if (!project || userLoading || unitLoading || signatureLoading || (user?.UnitId && signatureNotStarted)) return <Skeleton active />;

  const signature = user ? buildSenderSignature(user, unitSignature?.Signature ?? unit?.Name ?? '') : '';

  const initialValues = {
    Emails: [
      ...(project.ContractorEmail ? [ project.ContractorEmail ] : []),
      ...project.AdditionalRepresentatives.map(rep => rep.Email)
    ],
    Message: buildProjectEmail(project, signature)
  };

  const fields: FieldProps[] = [
    {
      name: 'Emails',
      type: FieldType.SELECT,
      selectProps: {
        tags: true,
        allowClear: false
      },
      required: true
    },
    {
      name: 'Message',
      type: FieldType.EDITOR,
      required: true
    },
  ];

  const handleSubmit = async (values: any) => {
    const emails = values.Emails.join(',');
    const data = { Emails: emails, ProjectId: project.Id, Message: values.Message };

    await sendEmail(data);
  };
  return <>
    <NoSignature />
    <DataForm
      id={Drawers.SEND_EMAIL}
      entity="project"
      onSubmit={handleSubmit}
      fields={fields}
      meta={meta}
      initialValues={initialValues}
      successMsg={t('forms.email.successmessage')}
    />
  </>;
};

export default SendEmail;
